import { useFormikContext } from "formik";
import React from "react";
import { Accordion } from "react-bootstrap";

import { RegimeTypes } from "../../../config/filingConstants";
import { IFormITR1 } from "../../../config/interfaces";
import PriceDisplay from "../../PriceDisplay";
import { ContextAwareToggle } from "../../accordion";

type Props = {};

const AccHousePropertyIncome: React.FC<Props> = (props: Props) => {
  const { values } = useFormikContext<IFormITR1>();
  const RegimeType = values?.FilingReturnInfo?.RegimeType;

  return (
    <>
      {values.TotalHousePropertyIncome ? (
        <>
          <Accordion.Item eventKey="income-source-2">
            <ContextAwareToggle eventKey="income-source-2" isChild={true}>
              <div className="btn-content justify-content-between">
                <p className="leading-para fw-bold mb-0">House Property Income</p>
                <p className="leading-para fw-bold mb-0">
                  <PriceDisplay price={values.TotalHousePropertyIncome} />
                </p>
              </div>
            </ContextAwareToggle>
            <Accordion.Body>
              <section>
                <dl className="eds-list eds-dl eds-inline-between">
                  {values?.HousePropertyIncomes?.TotalSelfOccupied &&
                  RegimeType === RegimeTypes.OLD_TAX_REGIME ? (
                    <div className="eds-list--item">
                      <dt>Self-occupied Properties (not given on rent)</dt>
                      <dd>
                        <PriceDisplay price={values.HousePropertyIncomes.TotalSelfOccupied} />
                      </dd>
                    </div>
                  ) : null}

                  {values?.HousePropertyIncomes?.TotalOnRent ? (
                    <div className="eds-list--item ">
                      <dt>Properties given on rent</dt>
                      <dd>
                        <PriceDisplay price={values.HousePropertyIncomes.TotalOnRent} />
                      </dd>
                    </div>
                  ) : null}

                  <div className="eds-list--item eds-list--item-subtotal">
                    <dt>Total:</dt>
                    <dd>
                      <PriceDisplay price={values.TotalHousePropertyIncome} />
                    </dd>
                  </div>
                </dl>
              </section>
            </Accordion.Body>
          </Accordion.Item>
        </>
      ) : null}
    </>
  );
};

export default AccHousePropertyIncome;
